import {
  ArrowDownTrayIcon,
  BookmarkSquareIcon,
  ChartPieIcon,
  EnvelopeIcon,
  PlusIcon,
} from '@heroicons/react/24/outline';

export const PLUS_FEATURES = [
  {
    key: 'analytics',
    icon: <ChartPieIcon className="size-6" />,
    titleKey: '高度な分析ツール',
    descKey: 'TreeMap と Transition で検索結果の傾向を直感的に把握できます。',
  },
  {
    key: 'filter-save',
    icon: <BookmarkSquareIcon className="size-6" />,
    titleKey: 'フィルター保存',
    descKey: 'よく使う条件を保存し、ワンクリックで呼び出せます。',
  },
  {
    key: 'themes',
    icon: <PlusIcon className="size-6" />,
    titleKey: '5つのテーマ追加',
    descKey: 'テーマの幅を広げて学びを深められます。',
  },
  {
    key: 'csv-download',
    icon: <ArrowDownTrayIcon className="size-6" />,
    titleKey: 'CSV ダウンロード 3000件/月',
    descKey: '月 3,000 件まで記事をエクスポートできます。',
  },
  {
    key: 'alert',
    icon: <EnvelopeIcon className="size-6" />,
    titleKey: 'アラート通知',
    descKey: '条件に合う新着記事をメールでお知らせします。',
  },
] as const;
